import { combineReducers } from 'redux';

import adminConstants from '../constants/admin.constant';
import { Redux } from '../types';

interface AdminStates {
  paymentViewEnabled: boolean;
}

const defaultState: AdminStates = {
  paymentViewEnabled: false,
};

const payment = (
  state: AdminStates = defaultState,
  action: Redux.SimpleAction
): AdminStates => {
  if (action.type === adminConstants.TOGGLE_PAYMENT_VIEW) {
    return {
      ...state,
      paymentViewEnabled: !state.paymentViewEnabled,
    };
  }

  return state;
};

export default combineReducers({
  payment,
});
